export const PLACEHOLDER_REGEX = /\{\{\s*(\w+)\s*\}\}/g;

export function extractPlaceholders(text: string | null | undefined): string[] {
  if (!text) {
    return [];
  }

  const found = new Set<string>();
  const regex = new RegExp(PLACEHOLDER_REGEX.source, PLACEHOLDER_REGEX.flags);
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    found.add(match[1]);
  }
  return [...found];
}
